module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->\r\n<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/custom-html/custom-html.component.html
// module id = ../../../../../src/app/shared/components/custom-html/custom-html.component.html
// module chunks = main